

const toPositiveNumber = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric >= 0 ? numeric : null;
};

const normalizeStatus = (status) => {
  if (typeof status === "boolean") {
    return status;
  }

  if (typeof status === "number") {
    return status === 1;
  }

  const normalized = String(status ?? "").trim().toLowerCase();
  return normalized === "true" || normalized === "active" || normalized === "1";
};

const extractRows = (source) =>
  source
    .map((item) => item)
    .map((item) => {
      const id = item.id ?? item.accountId ?? item.customerId ?? item.accountCode;
      const name = item.accountName ?? item.customerName ?? item.name ?? item.displayName ?? item.accountCode;
      const statusRaw = item.status ?? item.isActive ?? item.active;

      if (id === undefined || id === null || name === undefined || name === null) {
        return null;
      }

      return {
        id: String(id),
        name: String(name),
        status: normalizeStatus(statusRaw),
      };
    })
    .filter((item) => item !== null);

export const parseAccountResponse = (payload) => {
  let source = [];
  let total = 0;

  if (Array.isArray(payload)) {
    source = payload;
    total = payload.length;
  } else if (payload && typeof payload === "object") {
    const obj = payload;
    const nestedData = obj.data && typeof obj.data === "object" ? (obj.data) : null;

    if (Array.isArray(obj.content)) {
      source = obj.content;
    } else if (Array.isArray(obj.items)) {
      source = obj.items;
    } else if (Array.isArray(obj.data)) {
      source = obj.data;
    } else if (nestedData && Array.isArray(nestedData.content)) {
      source = nestedData.content;
    } else if (nestedData && Array.isArray(nestedData.items)) {
      source = nestedData.items;
    }

    total =
      toPositiveNumber(obj.totalElements) ??
      toPositiveNumber(obj.totalCount) ??
      toPositiveNumber(obj.total) ??
      toPositiveNumber(obj.count) ??
      toPositiveNumber(nestedData?.totalElements) ??
      toPositiveNumber(nestedData?.totalCount) ??
      toPositiveNumber(nestedData?.total) ??
      toPositiveNumber(nestedData?.count) ??
      source.length;
  }

  return {
    rows: extractRows(source),
    total,
  };
};
